import PrivateNetworkClient from "helpers/privateNetwork";

const getGatewayList = async (formData) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.post("/rfid/rfidList", formData);
  return data;
};

const addGateway = async (formData) => {
  const { data } = await PrivateNetworkClient.post("/rfid/addRFID", formData);
  return data;
};

const editGateway = async (formData) => {
  const { data } = await PrivateNetworkClient.put("/rfid/editRFID", formData);
  return data;
};

const deleteGateway = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.delete(`/rfid/delete/${id}`);
  return data;
};

const statusRfid = async (id) => {
  // if(localStorage.getItem('token') === null) {
  //   return null;
  // }
  const { data } = await PrivateNetworkClient.put(`/rfid/changeStatus/${id}`);
  return data;
}

const gatewayDropdownForFloor = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get(`/gateway_dropdown_for_floor/${id}`);
  return data;
};

const gatewayImageMapping = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get(`/gateway_floor_linked_List/${id}`);
  return data;
};

const gatewayFloorLinked = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get(`/gateway_floor_linked/${id}`);
  return data;
};

const gatewayFloorImage = async (id) => {
  const { data } = await PrivateNetworkClient.get(`/floor/getImageLocation/${id}`);
  return data;
};

const gatewayFloorImagePopup = async (id) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.get(`/floor/getImageLocation/${id}`);
  return data;
};
export {
  getGatewayList,
  addGateway,
  editGateway,
  deleteGateway,
  gatewayDropdownForFloor,
  gatewayImageMapping,
  gatewayFloorLinked,
  gatewayFloorImage,
  gatewayFloorImagePopup,
  statusRfid
};
